import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const inviteFriend = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.INVITATION.INVITE,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default inviteFriend
